import './extension/object'     // 类型扩展
import axios from './axios'
import Antd from './plugins/antd'
import echarts from './plugins/echarts'
import Custom from './plugins/custom'
import i18n from '../locales/local'
// import { createPinia } from 'pinia'
import pinia from './store'
import { App, reactive } from 'vue'
import globalErrorHandle from './error'
import util from './util'
import { router } from './router/router'
import VueCropper from 'vue-cropper'
import 'vue-cropper/dist/index.css'
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"


dayjs.extend(relativeTime)
dayjs.locale('zh-cn')

// 定义全局变量
window.$app = reactive<GlobalData>({ pageSettings: [], auth: [] })     // 商户及系统信息
window.$axios = axios
window.$util = util               // 通用方法
window.$router = router           // 路由

// 统一插件入口
export default {
  install: (app: App) => {
    app.use(pinia)            // 安装pinia
    app.use(router)           // 安装路由
    app.use(Antd)             // 安装antd
    app.use(Custom)           // 安装自定义组件
    app.use(i18n)             // 国际化
    app.use(VueCropper)       // 图片裁剪
    app.use(echarts)          // echarts图表

    // 定义vue全局变量，可在template中使用
    app.config.globalProperties.$app = $app
    app.config.globalProperties.$axios = axios
    app.config.globalProperties.$console = window.console
    app.config.globalProperties.$util = util
    app.config.errorHandler = globalErrorHandle     // 全局异常处理函数

  }
}

